export const deepClone = (source: any): any => {
  return JSON.parse(JSON.stringify(source))
}

export const findFirstElement = (parent: Element, targetClass: string) => {
  return parent.getElementsByClassName(targetClass)[0]
}

export const sleep = (msec: number) =>
  new Promise((resolve) => setTimeout(resolve, msec))

export const toSafeInt = (value: string): number | undefined => {
  const parsed = parseInt(value)
  return Number.isFinite(parsed) ? parsed : undefined
}
